import type { StoreApi, UseBoundStore } from 'zustand';

/**
 * Enhances a Zustand store with typed selector helpers.
 * Usage:
 * const store = createSelectors(create(...))
 * store((state) => state.value); // regular usage
 * store.use.value(); // memoized selector for a single field
 */
export function createSelectors<TState extends object>(
  store: UseBoundStore<StoreApi<TState>>
) {
  const useStore = store as UseBoundStore<StoreApi<TState>> & {
    use: { [K in keyof TState]: () => TState[K] };
  };

  useStore.use = useStore.use || ({} as any);

  const state = store.getState();
  Object.keys(state).forEach((key) => {
    Object.defineProperty(useStore.use, key, {
      get: () => () => useStore((s) => (s as any)[key]),
      enumerable: true,
    });
  });

  return useStore;
}


